module.exports = __webpack_public_path__ + "img/product-preview-45.4e0183b.png";